// Azure Speech Service Configuration
// Replace these with your actual Azure credentials

export const azureConfig = {
  subscriptionKey: '1MfeuVzKgAqURNvmHNJcZUhEdKPbzgg6xJ1sNT1WhsKl6ZEcWQPoJQQJ99BHAC5T7U2XJ3w3AAAYACOGvXOt', // Your Azure Speech Service key
  region: 'francecentral', // Your Azure region
  language: 'en-US',
  voiceName: 'en-US-JennyNeural' // High-quality neural voice
};

// Instructions:
// 1. Go to Azure Portal (https://portal.azure.com)
// 2. Navigate to your Speech Service resource
// 3. Go to "Keys and Endpoint" section
// 4. Copy Key 1 or Key 2
// 5. Copy the Region
// 6. Replace the values above
